import filter from 'lodash/filter';

const getDropdownMultiValues = (options, value = [], getOptionValue) =>
  filter(options, option => value.includes(getOptionValue(option)));

export default getDropdownMultiValues;
